import { Button } from '@talentmesh/ui/components/button';
import { cn } from '@talentmesh/ui/lib/utils';
import { Star } from 'lucide-react';
import { useCandidatesResultsContext } from '../../../Contexts/CandidateResultsContext';
import { useNotificationContext } from '@/Context/NotificationContext';
import { useCandidatesClient } from '@/Hooks/ClientHooks';

function CandidateFavorite() {
    const { assessmentId, results, updateIsFavorite } = useCandidatesResultsContext();
    const { showFailToaster } = useNotificationContext();
    const client = useCandidatesClient();

    return (
        <Button
            type="button"
            variant="ghost"
            size="icon"
            data-testid="FavoriteCheckbox"
            aria-pressed={results.isFavorite}
            aria-label={results.isFavorite ? 'Remove favorite' : 'Add favorite'}
            onClick={async () => {
                try {
                    const newValue = !results.isFavorite;
                    await client.saveFavoriteAsync(assessmentId, results.candidateId, newValue);
                    updateIsFavorite(newValue);
                } catch {
                    showFailToaster();
                }
            }}
        >
            <Star
                className={cn('size-5', results.isFavorite ? 'fill-primary text-primary' : 'text-muted-foreground')}
                aria-hidden
            />
        </Button>
    );
}

export default CandidateFavorite;
